<template>
  <div>
    <div v-for="item in upcomingMarkets" :key="item.series" class="mb-4">
      <v-card-text class="text-capitalize font-weight-bold py-0">{{
        item.series
      }}</v-card-text>
      <v-card
        v-for="(market, index) in item.markets"
        :key="index"
        class="card-rounded mb-2 mx-auto"
      >
        <v-row align="center" justify="center">
          <v-col cols="8" md="9">
            <div class="upcoming-border">
              <v-card-subtitle class="text-capitalize text-truncate py-1">
                <v-avatar color="#e1e1e1" size="32" class="mr-2">
                  <span class="black--text caption">IN</span>
                </v-avatar>
                {{ market.team1 }}</v-card-subtitle
              >
              <v-card-subtitle class="text-capitalize text-truncate py-1">
                <v-avatar color="#e1e1e1" size="32" class="mr-2">
                  <span class="black--text caption">AUS</span>
                </v-avatar>
                {{ market.team2 }}
              </v-card-subtitle>
              <v-card-subtitle class="f10 font-italic py-0">
                {{ market.date }}</v-card-subtitle
              >
            </div>
          </v-col>

          <v-col cols="4" md="3" class="pl-0">
            <div class="d-flex justify-center">
              <v-icon color="primary" class="mr-1"
                >mdi mdi-calendar-clock</v-icon
              >
              <v-card-text class="pa-0">
                <span class="text-decoration-underline"> Add to calender </span>
              </v-card-text>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      upcomingMarkets: [
        {
          series: '20-20 world cup',
          markets: [
            {
              team1: 'india',
              team2: 'australia',
              date: 'Friday, 3rd July, 7pm'
            },
            {
              team1: 'australia',
              team2: 'england',
              date: 'Friday, 3rd July, 7pm'
            },
            {
              team1: 'india',
              team2: 'england',
              date: 'Friday, 3rd July, 7pm'
            }
          ]
        },
        {
          series: 'indian premier league - 2020',
          markets: [
            {
              team1: 'india',
              team2: 'australia',
              date: 'Friday, 3rd July, 7pm'
            },
            {
              team1: 'australia',
              team2: 'england',
              date: 'Friday, 3rd July, 7pm'
            },
            {
              team1: 'india',
              team2: 'england',
              date: 'Friday, 3rd July, 7pm'
            }
          ]
        }
      ]
    }
  }
}
</script>
